import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from './orgao.model';

export class OrgaoIntegracao extends BaseResourceModel {

  constructor(
    public id?: number,
    public tipo_integracao?: 'BB' | 'NENHUMA',
    public aplicacao_integracao?: 'EXTRATO' | 'NENHUMA',
    public chave_acesso?: string,
    public usuario?: string,
    public senha?: string,
    public orgao?: Orgao,
  ) {
    super();
  }

  static converteJson(json: any): OrgaoIntegracao {
    return Object.assign(new OrgaoIntegracao(), json);
  }
}